//
//
//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ActivityEnum, AlertLevelEnum } from '@shared/Enums'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { dispatchError, OtStoreState } from '@react/redux/store'

import { alertActions } from '@react/redux/alertSlice'
import { ETH_ADDR_ZERO, EthAddr } from '@shared/SchemaTypes'

import { wsServerActionPoolTX } from '@shared/WsServerActions'

import { TxHash } from '@shared/SchemaTypes'
import { logOT } from '@shared/loggingShared'
import { ZeroHash } from 'ethers'

export const refreshPoolCTOThunk =
  (poolAddr: EthAddr): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.LOGIN
    try {
      const { webSocket, chainConfiguration } = getState().chainState
      const chainConfigurationName = chainConfiguration?.chainConfigurationName as string

      webSocket?.send(
        wsServerActionPoolTX(ActivityEnum.POOL_REFRESH, poolAddr, '', ZeroHash as TxHash, chainConfigurationName)
      )
      logOT.info('loginToChainThunk 6')
    } catch (e: any) {
      dispatch(
        alertActions.addAlert({
          title: 'Cound Login',
          description: 'Cound Login',
          createdAt: Date.now() / 1000,
          dueDateTime: Date.now() / 1000,
          txHash: '',
          sourceObjectAddr: ETH_ADDR_ZERO,
          alertLevel: AlertLevelEnum.ERROR,
        })
      )
      await dispatchError(dispatch, e, activity, 1057)
    }
  }
